import styled from 'styled-components';
import colors from 'Styles/colors';
import { ReactComponent as confirmedIcon } from 'Images/confirmed.svg';
import { ReactComponent as SendIcon } from 'Images/icon-action-bar-send.svg';

export const Wrapper = styled.div`
  
`;
Wrapper.displayName = 'Wrapper';

export const Blue = styled.div`
  color: ${colors.blueCerulean};
  display: inline-block;
  margin: 0px 5px;
`;
Blue.displayName = 'Blue';

export const ConfirmedIcon = styled(confirmedIcon)`
  width: 20px;
  height: 12px;
  margin: 0 5px 0 0px;
`;
ConfirmedIcon.displayName = 'ConfirmedIcon';

export const Send = styled(SendIcon)`
height: 17px;
g {
  fill: ${({ theme }) => theme.icons.actionBar.color};
}
g > path {
  fill: ${({ theme }) => theme.icons.actionBar.color};
}
`;

Send.displayName = 'Send';

export const Dropdown = styled.div`
  position: absolute;
  width: 127px;
  box-shadow: 2px 2px 10px 0 ${({ theme }) => theme.shadows.actionDropDown};
  background-color: ${({ theme }) => theme.backgrounds.actionDropDown};
  border: 1px solid ${({ theme }) => theme.borders.actionDropDown};
  border-radius: 0.25rem;
  z-index: 3;
`;
Dropdown.displayName = 'Dropdown';
